import ScrollColumn from "./ScrollColumn";
import "./CustomTimeInput.scss";
import { useState, useRef, useEffect } from "react";
import logger from "utils/logger";

    const CustomTimeInput = ({ date, onChange, onClickTimePicker, validateTimePicker, className, setOpenTimeSelector, openTimeSelecter }) => {
	const selectionRef = useRef(null);

    const [val, setVal] = useState( date != null && typeof date == "string" ?  new Date(Date.parse(date, "MM/dd/yyyy hh:mm a", new Date())).toLocaleTimeString([], {
					hour: "2-digit",
					minute: "2-digit", 
					hour12: true,
				}) : "");
    // Date.parse(date)
    logger.log(
        "lossDate: ", typeof date, date
    )
	useEffect(() => {
		if (openTimeSelecter && selectionRef.current) {
			selectionRef.current.focus();
		}
        // if(currentDate == "Invalid Date"){
        //     let tempDate = new Date();
        //     onChange(tempDate);
        // }
	}, [openTimeSelecter]);

	const hours = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0"));

	const minutes = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

	const periods = ["AM", "PM"];

	let currentDate = date != "Invalid Date" || date != null && typeof date == "string" ? new Date(Date.parse(date)) : new Date();

    // typeof date == "string" ? date : date != "Invalid Date" || date != null ? date : new Date()
    logger.log("currentDate: ", currentDate);
	const currentHour = currentDate?.getHours();
   
	const displayHour = currentHour % 12 === 0 ? "12" : String(currentHour % 12).padStart(2, "0");

	const displayMinute = String(currentDate?.getMinutes()).padStart(2, "0");

	const displayPeriod = currentHour >= 12 ? "PM" : "AM";

	const updateTime = (type, value) => {
		const newDate = new Date(currentDate);

		if (type === "hour") {
			let hour = parseInt(value);

			if (displayPeriod === "PM" && hour !== 12) {
				hour += 12;
			}

			if (displayPeriod === "AM" && hour === 12) {
				hour = 0;
			}

			newDate.setHours(hour);
		}

		if (type === "minute") {
			newDate.setMinutes(parseInt(value));
		}

		if (type === "period") {
			let hour = newDate.getHours();

			if (value === "PM" && hour < 12) {
				newDate.setHours(hour + 12);
			}

			if (value === "AM" && hour >= 12) {
				newDate.setHours(hour - 12);
			}
		}

		setVal(
			newDate.toLocaleTimeString([], {
				hour: "2-digit",
				minute: "2-digit",
				hour12: true,
			})
		);

		onChange(newDate);
	};

	const convertTimeToDate = timeStr => {
		const timeRegex = /^\s*(0?[1-9]|1[0-2]):([0-5][0-9])\s*(am|pm)\s*$/i;
		const valCheck = timeRegex.test(timeStr);
		if (!valCheck) {
			return "Invalid Date";
		}
		const now = new Date();
		const [time, modifier] = timeStr.split(" ");
		let [hours, minutes] = time.split(":");

		hours = Number(hours);
		minutes = Number(minutes);

		if (modifier?.toLowerCase() === "pm" && hours !== 12) {
			hours += 12;
		}

		if (modifier?.toLowerCase() === "am" && hours === 12) {
			hours = 0;
		}

		const date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);

		return date;
	};

	const formatTime = value => {
		if (!value) return "";

		// Allow digits, colon, space, a/p/m
		let cleaned = value.replace(/[^0-9aApPmM:\s]/g, "");

		// Detect full or partial am/pm at end
		const meridiemMatch = cleaned.match(/\s?(a|am|p|pm)$/i);
		let meridiem = "";

		if (meridiemMatch) {
			meridiem = meridiemMatch[1].toUpperCase();
			cleaned = cleaned.replace(/\s?(a|am|p|pm)$/i, "");
		}

		// Extract digits only for time formatting
		const digits = cleaned.replace(/\D/g, "").slice(0, 4);

		let result = "";

		if (digits.length <= 2) {
			result = digits;
		} else {
			result = digits.slice(0, 2) + ":" + digits.slice(2, 4);
		}

		if (meridiem) {
			result += " " + meridiem;
		}

		return result;
	};

	const isValidTime = time => {
		const match = time.match(/^(\d{2}):(\d{2})\s(AM|PM)$/i);
		if (!match) return false;

		const hours = Number(match[1]);
		const minutes = Number(match[2]);

		if (hours < 1 || hours > 12) return false;
		if (minutes < 0 || minutes > 59) return false;

		return true;
	};

	const maskAndValidateTime = value => {
		const formatted = formatTime(value);
		const isComplete = /^\d{2}:\d{2}\s(AM|PM)$/i.test(formatted);

		return {
			value: formatted,
			isValid: isComplete && isValidTime(formatted),
			isComplete,
		};
	};

	return (
		<div style={{ display: "flex", position: "relative", width: "100%" }}>
			<input
				id="timePicker"
				className={className}
				onChange={e => {
					const cleanedInput = maskAndValidateTime(e.target.value);

					if(cleanedInput.isValid && cleanedInput.isComplete){ 
                        const convResult = convertTimeToDate(cleanedInput.value);
                        onChange(convResult);
					} else if(!cleanedInput.isValid && !cleanedInput.isComplete){ 
                        const convResult = convertTimeToDate(cleanedInput.value); 
                        onChange(null); 
                        validateTimePicker({
                            errorMessage: "Please enter a time", 
                            touched: true
                        })
					}
					setVal(cleanedInput.value);
				}}
				value={val}
				onClick={ onClickTimePicker != undefined ? onClickTimePicker : () => {} }
				type="text"
				placeholder="--:-- --"
			/>
			{openTimeSelecter && (
				<div
					ref={selectionRef}
					tabIndex={0}
					onBlur={() => setOpenTimeSelector(false)}
					style={{
						display: "flex",
						position: "absolute",
						background: "white",
						zIndex: "9999",
						top: "55px",
						border: "1px solid #006485",
					}}
				>
					<ScrollColumn items={hours} value={displayHour} onSelect={val => updateTime("hour", val)} />
					<ScrollColumn items={minutes} value={displayMinute} onSelect={val => updateTime("minute", val)} />
					<ScrollColumn items={periods} value={displayPeriod} onSelect={val => updateTime("period", val)} />
				</div>
			)}
		</div>
	);
};

export default CustomTimeInput;
